import React, { memo, useState, useEffect } from "react";
import { useApiRequest } from "../../../hooks/useApiRequest";
import { API_BASE_URL, API_ENDPOINTS } from "../../../constant/constant";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { validationSchema } from "../../../yup/validationSchema";
import { QUOTATION_BTN, ENROLL_BTN } from "../../../constant/constant";
import Popup from "./Dialog";
import { filterObject } from "../../../utils/utils";

const EnquireForm = memo(({ formElements, tab }) => {
  const { isLoading, sendRequest } = useApiRequest();
  const [data, setData] = useState({});
  const [open, setOpen] = useState(false);
  const initialState = {
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    businessName: "",
    website: "",
    postalCode: "",
    description: "",
    emailVerified: false,
    verifyEmailOTP: "",
  };

  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: initialState,
  });

  const {
    handleSubmit,
    reset,
    watch,
    setError,
    formState: { errors },
  } = methods;

  const handleSubmitEnquiry = async (formData) => {
    try {
      const response = await sendRequest(
        `${API_BASE_URL}${API_ENDPOINTS.SUBMIT_ENQUIRY}`,
        "POST",
        formData
      );

      setData(response);
      setOpen(true);
      if (response.success) {
        reset();
      }
    } catch (error) {
      setOpen(true);
      setData(error);
    }
  };

  const onSubmit = (data) => {
    const emailVerified = watch("emailVerified");
    if (emailVerified) {
      const payload = filterObject(data, ["emailVerified", "verifyEmailOTP"]);
      handleSubmitEnquiry(payload);
    } else {
      setError("email", {
        type: "manual",
        message: "Email must be verified",
      });
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <FormProvider {...methods}>
        <form
          id="EnquireForm"
          className="EnquireForm mt-20 form-row"
          name="EnquireForm"
          onSubmit={handleSubmit(onSubmit)}
        >
          {formElements?.map((element) => {
            const { component, attribute, inputField = {} } = element;
            return (
              <div
                className={`form-group col-md-${attribute?.md} mb-20`}
                key={attribute?.id}
              >
                {component &&
                  React.createElement(component, {
                    attribute: {
                      ...attribute,
                    },
                    inputField: { ...inputField },
                  })}
              </div>
            );
          })}
          <div className="col-md-12">
            {isLoading ? (
              <button
                type="submit"
                className="theme-btn width_per_100"
                disabled
              >
                Loading
              </button>
            ) : (
              <button type="submit" className="theme-btn width_per_100">
                {tab === 1 ? QUOTATION_BTN : ENROLL_BTN}
              </button>
            )}
          </div>
        </form>
        <Popup open={open} handleClose={handleClose} data={data} />
      </FormProvider>
    </>
  );
});

export default memo(EnquireForm);
